module.exports = __webpack_public_path__ + "images/backgrounds/icon-pattern@2x_7037b86a8ac24e9f377deee97fd9d870.jpg";